module.exports = __webpack_public_path__ + "media/images/icon_nav_ranking-3a48483e4fa753e5e53c3eeeddac00f5.svg";